// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"93":"110130fc","395":"4c5c8264","466":"b40da7b3","746":"4b48c492"}[chunkId] + ".chunk.js";
};